import { createContext, useContext } from "react";

/** Cible de portail pour modales visibles en mode plein écran (API Fullscreen). */
export const PortalContainerContext = createContext(null);

export function usePortalContainer() {
  return useContext(PortalContainerContext);
}
